import { gql } from '@apollo/client'

export const CATEGORIE = gql`
  query Categorie {
    categorie {
      edges {
        node {
          slug
          url
        }
      }
    }
  }
`

export const CATEGORIA = gql`
  query Categoria($slugTree: String!, $preview: Boolean) {
    categoria(slugTree: $slugTree, preview: $preview) {
      pk
      titolo
      descrizione
      mainImage
      tipo
      model
      articoli {
        pk
        titolo
        abstract
        url
        previewImage
        numeroSettimana
        temi {
          pk
          nome
        }
      }
      next {
        titolo
        url
      }
      prev {
        titolo
        url
      }
      paginaHub {
        titolo
        mainImage
      }
      linkBox {
        titolo
        descrizione
        cta
        link
        blank
      }
      pagina {
        seo {
          title
          description
          image
          noindex
        }
        breadcrumbs {
          label
          url
        }
      }
    }
  }
`

export const ARTICOLO = gql`
  query Articolo($slug: String!, $preview: Boolean) {
    articolo(slug: $slug, preview: $preview) {
      pk
      titolo
      slug
      url
      descrizione
      mainImage
      consigliatiVisibili
      tipo
      model
      ordinamento
      numeroSettimana
      autore {
        label
        titolo
      }
      temi {
        pk
        nome
      }
      categoria {
        slugTree
      }
      pagina {
        seo {
          title
          description
          image
          noindex
        }
        breadcrumbs {
          label
          url
        }
      }
    }
  }
`

export const ARTICOLI = gql`
  query Articoli($categorie_id: ID) {
    articoli(categorie_Id: $categorie_id) {
      edges {
        node {
          slug
        }
      }
    }
  }
`

export const PAGINA = gql`
  query Pagina($chiave: String, $path: String, $preview: Boolean) {
    pagina(chiave: $chiave, path: $path, preview: $preview) {
      pk
      model
      titolo
      descrizione
      mainImage
      previewImage
      template
      site
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      chiave
    }
  }
`

export const PagineCatchAllDocument = gql`
  query PagineCatchAll {
    pagine(tipologia: "page") {
      edges {
        node {
          path
        }
      }
    }
  }
`

export const FAQS = gql`
  query AllFaqs {
    categorieFaq {
      pk
      slug
      titolo
      descrizione
      ordine
      faqs {
        pk
        slug
        domanda
        risposta
        ordine
      }
    }
  }
`

export const PRODOTTO_CONSIGLIATO = gql`
  query ProdottoConsigliato($pk: ID!) {
    prodottoConsigliato(pk: $pk) {
      pk
      titolo
      descrizione
      mainImage
      cta
      link
    }
  }
`

export const EVENTO = gql`
  query Evento($slug: String!) {
    evento(slug: $slug) {
      pk
      titolo
      descrizione
      noteAggiuntive
      mainImage
      form
      pagina {
        seo {
          title
          description
          image
          noindex
        }
        breadcrumbs {
          label
          url
        }
      }
    }
  }
`

export const EVENTI = gql`
  query Eventi {
    eventi {
      pk
      titolo
      slug
      abstract
      url
      previewImage
    }
  }
`

export const SEARCH = gql`
  query Search($query: String!, $first: Int, $last: Int, $after: String, $before: String) {
    search(query: $query, first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      count
      suggestion(query: $query)
      edges {
        node {
          object {
            ... on ArticoloNode {
              pk
              titolo
              descrizione
              abstract
              url
              mainImage
              numeroSettimana
              categoria {
                titolo
              }
            }
            ... on CategoriaNode {
              pk
              titolo
              descrizione
              url
              mainImage
            }
            ... on PaginaNode {
              pk
              titolo
              descrizione
              url
              mainImage
            }
          }
          modelName
          score
          url
        }
      }
    }
  }
`

export const AUTOCOMPLETE = gql`
  query Autocomplete($query: String!) {
    autocomplete(query: $query) {
      object {
        ... on ArticoloNode {
          pk
          titolo
          url
        }
        ... on CategoriaNode {
          pk
          titolo
          url
        }
        ... on PaginaNode {
          pk
          titolo
          url
        }
      }
    }
  }
`

export const PAGINA_HUB = gql`
  query PaginaHub($chiave: String!) {
    pagina(chiave: $chiave) {
      pk
      titolo
      descrizione
      mainImage
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      elementi {
        titolo
        descrizione
        mainImage
        url
        cta
        blank
      }
      chiave
    }
  }
`

export const AUTORI = gql`
  query Autori {
    autori {
      titolo
      abstract
      previewImage
    }
  }
`

export const CATEGORIA_PRODOTTO = gql`
  query CategoriaProdotto($slug: String!) {
    categoriaProdotto(slug: $slug) {
      template
      titolo
      slug
      descrizione
      mainImage
      video
      labelProdotti
      children {
        pk
        titolo
        descrizione
        prodotti {
          pk
          titolo
          descrizione
          mainImage
          cta
          blank
          link
          informazioniAggiuntive {
            pk
            descrizione
            image
          }
        }
      }
      siblings {
        pk
        titolo
        previewImage
        url
      }
    }
  }
`
